"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormControl = void 0;
const event_1 = require("@/common/event");
const ui_1 = require("@/ui/ui");
const controlDefaultOptions = {
    disabled: false
};
class FormControl extends ui_1.Component {
    constructor(element, target, defaultOptions, _options) {
        super(element, target, Object.assign(Object.assign({}, controlDefaultOptions), defaultOptions), _options);
        // events
        this._onDidChange = new event_1.Emitter();
        if (this._options.id)
            this._element.id = this._options.id;
        this._register(this._onDidChange);
    }
    get id() {
        return this._options.id;
    }
    get onDidChange() {
        return this._onDidChange.event;
    }
}
exports.FormControl = FormControl;
